import { Flex, Typography } from '@banhala/ui-kit';

type Props = {
  value: string;
  onChange: (date: string) => void;
};

const MIN_DATE = '1900-01-01';

/**
 * 웹 생년월일 입력. ui-kit 날짜 피커가 없어 DOM date input을 쓰되, 필드 모양은 직접
 * 그리고 input은 값 텍스트만 숨긴 오버레이로 얹는다.
 */
export const BirthdaySelector = ({ value, onChange }: Props) => {
  // toISOString은 UTC라 KST 새벽에 하루 어긋난다.
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  const isEmpty = value === '';

  return (
    <Flex
      padding={{ vertical: 12, horizontal: 12 }}
      borderWidth={1}
      borderColor={'border_secondary'}
      borderRadius={8}
      justifyContent={'center'}
    >
      <Typography
        type={'body1'}
        color={isEmpty ? 'content_tertiary' : 'content_primary'}
      >
        {isEmpty ? '생년월일 입력' : value}
      </Typography>
      <input
        type={'date'}
        aria-label={'생년월일'}
        value={value}
        min={MIN_DATE}
        max={today}
        onChange={event => onChange(event.target.value)}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          margin: 0,
          padding: 0,
          border: 'none',
          background: 'transparent',
          // 표시는 Typography가 하므로 UA가 그리는 값만 숨긴다. opacity:0으로 통째로
          // 감추면 탭 → 네이티브 피커 경로가 끊긴다.
          color: 'transparent',
          WebkitTextFillColor: 'transparent',
          // appearance auto면 iOS Safari가 box-sizing을 content-box로 강제해 padding만큼 넘친다.
          WebkitAppearance: 'none',
          appearance: 'none',
          // 16px 미만은 iOS Safari가 포커스 시 확대한다.
          fontSize: 16,
          boxSizing: 'border-box',
        }}
      />
    </Flex>
  );
};
